// @ts-nocheck
import { getInvoicePdf, GetInvoicePdfApiParameter, InvoicePdf } from "@store/Framework/Services/InvoiceService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export type DownloadInvoiceProps = {
    error?: any;
};

export type DownloadInvoiceHandlerType = ApiHandler<
    GetInvoicePdfApiParameter & HasOnSuccess<InvoicePdf> & HasOnError<any>,
    InvoicePdf,
    DownloadInvoiceProps
>;

export const DispatchBeginDownload: DownloadInvoiceHandlerType = props => {
    props.dispatch({ type: "Store/Pages/InvoiceDetails/BeginDownload", invoiceNumber: props.parameter.invoiceNumber });
};

export const PopulateApiParameter: DownloadInvoiceHandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: DownloadInvoiceHandlerType = async props => {
    try {
        props.apiResult = await getInvoicePdf(props.apiParameter);
    } catch (error) {
        props.error = error;
    }
};

export const DispatchCompleteDownload: DownloadInvoiceHandlerType = props => {
    props.dispatch({
        type: "Store/Pages/InvoiceDetails/CompleteDownload",
        invoiceNumber: props.parameter.invoiceNumber,
    });
};

export const ExecuteOnSuccessCallback: DownloadInvoiceHandlerType = props => {
    if (!props.error) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: DownloadInvoiceHandlerType = props => {
    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [
    DispatchBeginDownload,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteDownload,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const downloadInvoice = createHandlerChainRunner(chain, "DownloadInvoice");
export default downloadInvoice;
